export const parseTimeInput = (input: string): number | null => {
  const trimmed = input.trim().toLowerCase();
  if (!trimmed) return null;

  // Strict pattern: Optional hours part followed by optional minutes part.
  // Supports: h, hr, hour, hours, m, min, minute, minutes
  // It will strictly reject repeated units like "2h2h" or inverted units like "30m 2h".
  const strictPattern = /^(?:(\d+)\s*(?:hours|hour|hr|h))?\s*(?:(\d+)\s*(?:minutes|minute|min|m))?$/;

  const match = trimmed.match(strictPattern);

  if (!match) return null;

  const hoursStr = match[1];
  const minutesStr = match[2];

  // If it matched an empty string (both undefined)
  if (!hoursStr && !minutesStr) return null;

  let totalMinutes = 0;
  
  if (hoursStr) {
    totalMinutes += parseInt(hoursStr, 10) * 60;
  }
  
  if (minutesStr) {
    totalMinutes += parseInt(minutesStr, 10);
  }

  return totalMinutes;
};

export const formatTimeSpent = (totalMinutes: number): string => {
  if (!totalMinutes || totalMinutes === 0) return '0m';
  
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;
  
  const parts = [];
  if (hours > 0) parts.push(`${hours}h`);
  if (minutes > 0) parts.push(`${minutes}m`);
  
  return parts.join(' ');
};
